export default {
  allowedLinks: []
}
